import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/ic_tips.png';

const _withScopeId = n => (_pushScopeId("data-v-98ba4454"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "cms-card-block"
};
const _hoisted_3 = {
  class: "cms-module-title mg-t--15"
};
const _hoisted_4 = {
  key: 0,
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  }
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "cursor": "pointer"
  },
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1));

const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "btn-operate"
};
const _hoisted_11 = {
  class: ""
};
const _hoisted_12 = {
  class: "themes-tree-warp"
};
const _hoisted_13 = {
  class: "left-warp"
};
const _hoisted_14 = {
  class: "header"
};
const _hoisted_15 = {
  class: "main"
};
const _hoisted_16 = {
  class: "item"
};
const _hoisted_17 = {
  class: "check-warp"
};
const _hoisted_18 = {
  class: "item-type"
};
const _hoisted_19 = {
  class: "right-warp"
};
const _hoisted_20 = {
  class: "header"
};
const _hoisted_21 = {
  class: "flex1 text-left"
};
const _hoisted_22 = {
  class: "flex1 text-center"
};
const _hoisted_23 = {
  class: "flex1 text-right"
};
const _hoisted_24 = {
  class: "main"
};
const _hoisted_25 = {
  class: "item"
};
const _hoisted_26 = {
  class: "item-type text-center"
};
const _hoisted_27 = ["onClick"];
import ActionHeader from '@/views/common/ActionHeader/index.vue';
import FormTable from '@/components/FormTable/index.vue';
import Buttons from '@/components/Buttons/index.vue';
import Column from '@/components/CommonTable/Column.vue';
import SearchInput from '@/components/SearchInput/index.vue';
import { getRelationThemesApi, addOperationPlanApi, editOperationPlanApi, getTopicListApi } from '@/api/vodNew';
import { useI18n } from 'vue-i18n';
import { ref } from 'vue';
import { messageBox, validatorNonNull } from "@/utils/validate";
import { elMessage, getTextWidth } from '@/utils';
import { safeOpenUrl } from '@/utils/sanitize';
import { clearData } from '@/utils/tools';
import { ElMessage } from 'element-plus';
import { addDynamicPlanApi, editDynamicPlanApi, getDynamicThemeApi, getBindingPlanListApi } from '@/api/topic';
import { themeTypeOptions } from '@/assets/config/dicts';
const __default__ = {
  name: "PlanAction"
};
export default /*#__PURE__*/_defineComponent({ ...__default__,
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    topicType: {
      type: String,
      default: 'dynamic'
    },
    action: {
      type: String,
      default: 'add',
      validator: value => ['add', 'edit', 'check'].includes(value)
    },
    sourceData: {
      type: Object,
      default: {}
    }
  },
  emits: ['update:modelValue', 'updateList'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const FormRef = ref();
    const tooltipContent = ref(t('快速双击排序序号,在输入框编辑排序'));
    const tableRef = ref();
    watch(() => props.modelValue, val => {
      clearData(searchConfig.formData);
      clearData(actionForm.formData);
      clearData(topiData);

      if (val) {
        headerConfig.title = props.action == 'add' ? '新增方案' : props.action == 'edit' ? '编辑' : '查看';
        actionForm.formData.type = props.topicType ? props.topicType : '';

        if (props.action !== 'add') {
          setDataParams();
          getRelationThemes(props.sourceData.id);
        }
      } else {
        actionTable.data = [];
      }
    }); // 数据回显

    const setDataParams = () => {
      actionForm.formData.description = props.sourceData.description;
      actionForm.formData.name = props.sourceData.name;
    };

    const viewLoading = ref(false); // 查看获取关联的主题

    const getRelationThemes = async id => {
      if (id) {
        try {
          viewLoading.value = true;
          const {
            code,
            data
          } = actionForm.formData.type === 'static' ? await getRelationThemesApi({
            planId: id
          }) : await getBindingPlanListApi(id);

          if (code == 0) {
            actionTable.data = data.map((item, index) => {
              return { ...item,
                c_type: item.type === 'fixed' ? t('固定') : t('运营'),
                sequence: index + 1,
                isInput: false // 编辑模式

              };
            });
            topiData.selectData = data;
            topiData.selectIdData = data.map(item => item.id);
            viewLoading.value = false;
          } else {
            viewLoading.value = false;
          }
        } catch (error) {
          viewLoading.value = false;
        }
      }
    };

    const headerConfig = reactive({
      title: '',
      btnList: [{
        label: '返回',
        func: () => {
          emits('update:modelValue', false);
        }
      }]
    }); // 搜索框配置

    const searchConfig = reactive({
      formData: {
        name: ''
      },
      formList: [{
        label: '关键字',
        prop: 'name',
        widgetType: 'input',
        placeholder: '请输入关键字',
        style: 'width: 290px'
      }],
      search: () => {}
    }); // 添加 选择主题 弹框配置

    const addThemesModalConf = reactive({
      modalVis: false,
      options: {
        title: '选择主题'
      },
      onConfirm: () => {
        // actionTable.data = [...topiData.selectData]
        actionTable.data = topiData.selectData ? topiData.selectData.map((item, index) => {
          return { ...item,
            sequence: index + 1
          };
        }) : [];
        addThemesModalConf.modalVis = false;
        console.log('onConfirm', topiData);
      },
      onClose: () => {
        console.log(topiData);
        console.log(actionTable.data);
        topiData.selectData = [...actionTable.data];
        topiData.selectIdData = actionTable.data.map(item => {
          return item.id;
        });
      }
    });
    const buttonsList = ref([{
      label: '选择主题',
      func: () => {
        if (!actionForm.formData.type) return ElMessage({
          type: 'warning',
          message: t('请选择主题方式')
        });
        clearData(searchConfig.formData);
        addThemesModalConf.modalVis = true;
        getTopicList({
          pageSize: -1
        });
        topiData.selectData = [...actionTable.data];
        topiData.selectIdData = actionTable.data.map(item => item.id);
      }
    }]); // 方案输入校验

    const validatorThemesName = (rule, value, callback) => {
      if (value == undefined || value.length == 0) {
        callback(new Error(t('请输入方案名称')));
      } else {
        callback();
      }
    };

    const actionForm = reactive({
      formList: [[{
        label: '方案名称',
        prop: 'name',
        widgetType: 'input',
        controller: (value, data, config) => {
          config.widgetType = props.action === 'check' ? 'text' : 'input';
          return true;
        },
        required: true,
        placeholder: '请输入方案名称'
      }, {
        label: '主题方式',
        prop: 'type',
        list: themeTypeOptions,
        widgetType: 'Select',
        controller: (value, data, config) => {
          config.widgetType = props.action === 'check' ? 'text' : 'Select';
          config.disabled = props.action === 'edit';
          return true;
        },
        change: val => {
          // 发生变化，清空主题数据
          topiData.selectData = [];
          topiData.selectIdData = [];
          actionTable.data = [];
        },
        required: true
      }], [{
        label: '描述',
        prop: 'description',
        widgetType: 'textarea',
        controller: (value, data, config) => {
          config.widgetType = props.action === 'check' ? 'text' : 'textarea';
          return true;
        },
        maxlength: 100,
        colspan: 3,
        showWordLimit: true,
        autosize: true
      }]],
      formData: {
        name: '',
        description: ''
      },
      rules: {
        name: [{
          required: true,
          validator: (rule, value, callback) => validatorNonNull(rule, value, callback, '请输入方案名称')
        }, {
          max: 50,
          message: t('限制字符数量', {
            num: '50'
          }),
          trigger: 'blur'
        }],
        type: [{
          required: true,
          validator: (rule, value, callback) => validatorNonNull(rule, value, callback, '请选择主题类型')
        }]
      }
    });
    const actionTable = reactive({
      data: [],
      isShowHeader: false,
      showPageBar: false,
      isCardBlock: false,
      columnList: [{
        label: '序号',
        prop: 'sequence',
        width: 150,
        cellSlot: true,
        slotName: 'sequenceColumn'
      }, {
        label: '主题名称',
        prop: 'name'
      }, {
        label: '主题类型',
        prop: 'c_type',
        width: 130
      }, // {
      //     label: '主题内容类型', prop: 'contentType', width: 130,
      //     formatter: (val) => {
      //         if (val !== undefined && val !== '' && val !== null) {
      //             return t(val + '_s')
      //         }
      //     }
      // },
      {
        label: '推荐位模板',
        prop: 'imgUrl',
        cellSlot: true,
        width: 200,
        controller: () => actionForm.formData.type === 'static'
      }, {
        label: '推荐位模板',
        prop: 'themeTemplateComponentList',
        showOverflowTooltip: false,
        cellSlot: true,
        width: 200,
        controller: () => actionForm.formData.type !== 'static'
      }, {
        label: '描述',
        prop: 'description'
      }, {
        label: '操作',
        widgetType: 'buttons',
        buttonsList: [{
          label: '删除',
          func: row => {
            console.log(row);
            messageBox('确定删除这条数据吗?').then(async () => {
              const {
                id
              } = row;
              handleDeleteItem(actionTable.data, id);
              handleDeleteItem(topiData.selectData, id);
              handleDeleteItem(topiData.selectIdData, id);
            });
          }
        }],
        controller: (value, data, config) => {
          return props.action == 'check' ? false : true;
        }
      }]
    }); // 删除数组内对应数据方法

    const handleDeleteItem = (arr, id) => {
      const deleteItem = arr.findIndex(item => {
        return item.id === id;
      });
      arr.splice(deleteItem, 1);
    }; //返回按钮


    const Back = () => {
      emits('update:modelValue', false);
    }; // 完成/编辑事件


    const handleComplete = () => {
      FormRef.value.mForm.validate(async valid => {
        if (valid) {
          if (topiData.selectIdData.length == 0) {
            elMessage('error', '请选择主题');
          } else {
            actionForm.formData.name = actionForm.formData.name.trim();
            let ids = actionTable.data.map(item => item.id);
            const params = { ...actionForm.formData,
              themeIds: ids,
              id: props.sourceData.id
            };

            if (!props.sourceData.id) {
              console.log('新增');
              const res = actionForm.formData.type === 'static' ? await addOperationPlanApi(params) : await addDynamicPlanApi(params);

              if (res.code == 0) {
                elMessage('success', '新增成功');
                emits('update:modelValue', false);
                emits('updateList');
              }
            } else {
              console.log('编辑');
              const res = actionForm.formData.type === 'static' ? await editOperationPlanApi(params) : await editDynamicPlanApi(params);

              if (res.code == 0) {
                elMessage('success', '编辑成功');
                emits('update:modelValue', false);
                emits('updateList');
              }
            }
          }
        }
      });
    }; // 获取主题列表


    const getTopicList = async params => {
      topiData.config.loading = true; // 区分静态||动态主题，前提要选择了主题类型

      const res = actionForm.formData.type == 'static' ? await getTopicListApi(params) : await getDynamicThemeApi(params);
      console.log(253, res);

      if (res.code == 0) {
        topiData.list = res.data.map(item => {
          return { ...item,
            check: isSelect(item.id),
            c_type: item.type === 'fixed' ? t('固定') : t('运营')
          };
        });
      }

      topiData.config.loading = false;
    }; // 判断主题列表checkbox是否选中


    const isSelect = id => {
      let idx = topiData.selectIdData.indexOf(id);
      return idx === -1 ? false : true;
    }; // 选择主题数据内容


    const topiData = reactive({
      list: [],
      selectData: [],
      selectIdData: [],
      config: {
        loading: false
      }
    }); // 选择主题 checkbox 点击事件

    const handleCheckChange = (item, id) => {
      console.log(290, item, id);
      let idx = topiData.selectIdData.indexOf(id);

      if (idx === -1) {
        topiData.selectIdData.push(id);
        topiData.selectData.push(item);
      } else {
        topiData.selectIdData.splice(idx, 1);
        topiData.selectData.splice(idx, 1);
      }
    }; // 选择主题待选框内删除事件


    const handleDelectItem = id => {
      let idx = topiData.selectIdData.indexOf(id);

      if (idx !== -1) {
        updateSelect(id);
        topiData.selectData.splice(idx, 1);
        topiData.selectIdData.splice(idx, 1);
      }
    }; // 更新 checkbox 点击后数据属性


    const updateSelect = id => {
      const item = topiData.list.find(item => {
        return item.id === id;
      });
      item.check = false;
    }; // 搜索点击事件


    const handleSearch = data => {
      const {
        name
      } = data;
      getTopicList({
        name,
        pageSize: -1
      });
    }; // 重置按钮点击事件


    const handleReset = () => {
      getTopicList({
        pageSize: -1
      });
    }; //  内容超出时显示提示


    const tipDisabled = ref(false);

    const showTextTip = e => {
      const target = e.target;
      const width = getTextWidth(target.innerText);
      tipDisabled.value = target.offsetWidth < width;
    }; // 双击表格


    const onDbClick = (row, column, cell, event) => {
      if (column.label == '序号' && props.action !== 'check') {
        return row.isInput = true;
      }
    };

    function updateSequenceAndReorder(arr, id, newSequence) {
      // 找到需要更新的元素
      const element = arr.find(item => item.id === id);
      if (!element) return arr; // 如果没找到，返回原数组
      // 移除目标元素

      arr = arr.filter(item => item.id !== id); // 插入目标元素到新的 sequence 位置

      arr.splice(newSequence - 1, 0, element); // 重新分配连续的 sequence，从 1 开始

      arr.forEach((item, index) => {
        item.sequence = index + 1;
      });
      return arr;
    }

    const onInputBlur = row => {
      if (row.sequence === '' || row.sequence == 0) {
        row.sequence = row.index + 1;
      } else {
        let maxNum = actionTable.data.length;
        let oldValue = row.index + 1; // 旧的排序值

        let newvalue = row.sequence; // 新排序

        if (newvalue != oldValue) {
          // 修改排序重排数组
          if (newvalue <= maxNum) {
            const newArr = updateSequenceAndReorder(actionTable.data, row.id, newvalue);
            actionTable.data = newArr;
          } else {
            const newArr = updateSequenceAndReorder(actionTable.data, row.id, oldValue);
            actionTable.data = newArr;
          }
        }
      }

      row.isInput = false;
    }; // 打开图片


    const recommendImageClick = imgUrl => {
      const url = safeOpenUrl(imgUrl);
      if (url) window.open(url);
    };

    return (_ctx, _cache) => {
      const _component_el_tooltip = _resolveComponent("el-tooltip");

      const _component_el_popover = _resolveComponent("el-popover");

      const _component_el_input = _resolveComponent("el-input");

      const _component_CommonTable = _resolveComponent("CommonTable");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_MPopper = _resolveComponent("MPopper");

      const _component_MDialog = _resolveComponent("MDialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [__props.modelValue ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(ActionHeader, {
        config: headerConfig
      }, null, 8, ["config"]), _createElementVNode("div", _hoisted_2, [_createVNode(FormTable, {
        ref_key: "FormRef",
        ref: FormRef,
        col: ['20%', '30%', '20%', '30%'],
        "form-list": actionForm.formList,
        "form-data": actionForm.formData,
        formRules: actionForm.rules
      }, null, 8, ["form-list", "form-data", "formRules"]), _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('关联主题')), 1), __props.action !== 'check' ? (_openBlock(), _createBlock(Buttons, {
        key: 0,
        class: "mg-b--15",
        buttonsList: buttonsList.value
      }, null, 8, ["buttonsList"])) : _createCommentVNode("", true), _createVNode(_component_CommonTable, {
        "table-config": actionTable,
        ref_key: "tableRef",
        ref: tableRef,
        onCellDblclick: onDbClick
      }, {
        default: _withCtx(() => [_createVNode(Column, {
          "column-list": actionTable.columnList
        }, {
          title: _withCtx(column => [column.nodeDate.prop == 'sequence' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("span", null, _toDisplayString(_ctx.$t(column.label)), 1), _createVNode(_component_el_tooltip, {
            "popper-class": "self-popper",
            content: tooltipContent.value,
            placement: "top",
            effect: "light"
          }, {
            default: _withCtx(() => [_hoisted_5]),
            _: 1
          }, 8, ["content"])])) : _createCommentVNode("", true)]),
          cellSlot: _withCtx(scope => [scope.column.property === 'imgUrl' ? (_openBlock(), _createBlock(_component_el_popover, {
            key: 0,
            placement: "bottom-start",
            width: 150,
            trigger: "hover"
          }, {
            reference: _withCtx(() => [_createElementVNode("img", {
              class: "logo",
              src: scope.row.imgUrl,
              alt: ""
            }, null, 8, _hoisted_6)]),
            default: _withCtx(() => [_createElementVNode("img", {
              style: {
                "width": "130px",
                "display": "inline-block",
                "text-align": "center"
              },
              src: scope.row.imgUrl,
              alt: ""
            }, null, 8, _hoisted_7)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), scope.row.themeTemplateComponentList && scope.row.themeTemplateComponentList.length ? (_openBlock(), _createBlock(_component_el_popover, {
            key: 1,
            width: 154,
            trigger: "hover",
            placement: "top"
          }, {
            reference: _withCtx(() => [_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.themeTemplateComponentList || [], (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index + '_c'
              }, [_createElementVNode("div", {
                class: "link",
                onClick: $event => recommendImageClick(item.layoutImage),
                style: {
                  "white-space": "nowrap",
                  "text-overflow": "ellipsis",
                  "overflow": "hidden"
                }
              }, _toDisplayString(item.layoutImage), 9, _hoisted_8)]);
            }), 128))])]),
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.themeTemplateComponentList || [], (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, [_createElementVNode("div", null, [_createElementVNode("img", {
                style: {
                  "width": "100%",
                  "height": "100%"
                },
                src: item.layoutImage,
                alt: ""
              }, null, 8, _hoisted_9)])]);
            }), 128))]),
            _: 2
          }, 1024)) : _createCommentVNode("", true)]),
          sequenceColumn: _withCtx(scope => [_withDirectives(_createElementVNode("span", null, _toDisplayString(scope.row.sequence), 513), [[_vShow, !scope.row.isInput]]), _withDirectives(_createVNode(_component_el_input, {
            modelValue: scope.row.sequence,
            "onUpdate:modelValue": $event => scope.row.sequence = $event,
            placeholder: "",
            class: "EL__focus",
            onBlur: $event => onInputBlur(scope.row),
            oninput: "value=value.replace(/^(0+)|[^\\d]+/g,'')",
            maxlength: "10"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"]), [[_vShow, scope.row.isInput]])]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config"]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
        class: "btn-cancel cms-op-btn-non-focus",
        onClick: Back
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('取消')), 1)]),
        _: 1
      }), __props.action !== 'check' ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        class: "btn-confirm",
        onClick: handleComplete
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('确定')), 1)]),
        _: 1
      })) : _createCommentVNode("", true)])])])), [[_directive_loading, viewLoading.value]]) : _createCommentVNode("", true), _createVNode(_component_MDialog, {
        modelValue: addThemesModalConf.modalVis,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => addThemesModalConf.modalVis = $event),
        dialogConfig: addThemesModalConf.options,
        specialClass: "add__channel__dialog",
        onOnConfirm: addThemesModalConf.onConfirm,
        onOnClose: addThemesModalConf.onClose
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(SearchInput, {
          labelWidth: "120px",
          size: {
            xs: 24,
            sm: 24,
            md: 12,
            lg: 12,
            xl: 12
          },
          "form-list": searchConfig.formList,
          "form-data": searchConfig.formData,
          onSearch: handleSearch,
          onReset: handleReset
        }, null, 8, ["form-list", "form-data"])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('主题名称')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('主题类型')), 1)]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topiData.list, (item, index) => {
          return _openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_checkbox, {
            onChange: $event => handleCheckChange(item, item.id),
            modelValue: item.check,
            "onUpdate:modelValue": $event => item.check = $event
          }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"]), _createVNode(_component_MPopper, {
            disabled: tipDisabled.value,
            placement: "top",
            trigger: "hover",
            content: item.name
          }, {
            reference: _withCtx(() => [_createElementVNode("span", {
              onMouseover: showTextTip,
              class: "item-name"
            }, _toDisplayString(item.name), 33)]),
            _: 2
          }, 1032, ["disabled", "content"])]), _createElementVNode("span", _hoisted_18, _toDisplayString(item.c_type), 1)]);
        }), 256))])), [[_directive_loading, topiData.config.loading]])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('主题名称')), 1), _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('主题类型')), 1), _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('操作')), 1)]), _createElementVNode("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topiData.selectData, (item, index) => {
          return _openBlock(), _createElementBlock("div", _hoisted_25, [_createVNode(_component_MPopper, {
            disabled: tipDisabled.value,
            placement: "top",
            trigger: "hover",
            content: item.name
          }, {
            reference: _withCtx(() => [_createElementVNode("span", {
              onMouseover: showTextTip,
              class: "item-name"
            }, _toDisplayString(item.name), 33)]),
            _: 2
          }, 1032, ["disabled", "content"]), _createElementVNode("span", _hoisted_26, _toDisplayString(item.c_type), 1), _createElementVNode("span", {
            class: "delete text-right",
            onClick: $event => handleDelectItem(item.id)
          }, _toDisplayString(_ctx.$t('删除')), 9, _hoisted_27)]);
        }), 256))])])])]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm", "onOnClose"])], 64);
    };
  }

});